import type { DanceSeoHead } from "../danceSeoTypes.js";

// Search Console, Aug 29 - Sep 26 2026. The full-song page's queries are
// "ai dance video generator", "ai dance generator from music", "music to
// dance video ai" and their "free" variants; the photo page's are "photo
// dance", "make a photo dance", "ai dance generator from photo", "photo dance
// ai". One head term per page: the first owns "AI dance video generator",
// the second owns "photo dance / from photo".
const head: DanceSeoHead = {
  director: {
    title: "AI Dance Video Generator from Music — Free to Start",
    description:
      "Turn any song into a full AI dance video. Solmi plans choreography for every section, storyboards each shot and renders dance and lip-sync shots. Free to start.",
    h1: "AI Dance Video Generator — Turn Any Song into a Dance Video",
  },
  photo: {
    title: "Make a Photo Dance — AI Dance Generator from Photo | Solmi",
    description:
      "Make a photo dance with AI: upload a full-body photo, pick a move or upload your own dance clip, add a song. Solmi syncs the dance to the beat. Free to start.",
    h1: "Make a Photo Dance — AI Dance Generator from Photo",
  },
  inbound:
    "Want the performer to dance? The [AI dance video generator](/ai-dance-video-generator) plans choreography for every section of your song and renders a full dance video.",
};

export default head;
